import { Attribute, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { FormUtils } from '@rx-applications/shared/utils-forms';
import { TRANSLOCO_SCOPE, TranslocoService } from '@ngneat/transloco';
import { inlineLoaderFactory } from '@rx-applications/shared/utils';
import { MaxLengths, MinLengths } from '@roomex/rx-components';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-validation-messages',
  templateUrl: './validation-messages.component.html',
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'validationMessages',
        loader: inlineLoaderFactory((lang: string) => import(`./assets/i18n/${lang}.json`)),
      },
    },
  ],
})
export class ValidationMessagesComponent extends FormUtils {
  /**
   * @prop the form to validate
   */
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  @Input() form: UntypedFormGroup;

  /**
   * @prop the array of translations
   */
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  @Input() translationsPath: string;

  /**
   * enums to use in the template
   */
  readonly MaxLengths = MaxLengths;
  readonly MinLengths = MinLengths;

  constructor(@Attribute('field') public field: string, private readonly transloco: TranslocoService) {
    super();
    this.field = field;
  }

  get patternMatchesError$(): Observable<string | null> {
    if (!this.isFieldInvalid(this.form, this.field, 'patternMatches')) {
      return of(null);
    }
    const characterMatches = this.getError(this.form, this.field, 'patternMatches');

    const translationKeys =
      characterMatches.length > 1
        ? [this.doTranslate('fieldMustNotContain'), this.doTranslate('orLastValue')]
        : [this.doTranslate('fieldMustNotContain')];

    return this.transloco
      .selectTranslate(translationKeys, this.buildPatternMatchesParams(characterMatches))
      .pipe(map((translationMap) => Object.values(translationMap).join(' ')));
  }

  doTranslate(ext: string): string {
    return `validationMessages.${this.translationsPath}.${ext}`;
  }

  getReadValue(): string {
    return `validationMessages.${this.translationsPath}`;
  }

  private buildPatternMatchesParams(characterMatches: string[]) {
    const characterCount = characterMatches.length;
    return characterCount > 1
      ? {
          values: characterMatches.slice(0, characterCount - 1).join(', '),
          lastValue: characterMatches[characterCount - 1],
        }
      : { values: characterMatches.join(', ') };
  }
}
